require('./lastStatementBox.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
// @ commons
const { FormattedText, getLanguage } = require('core/i18n').i18n;
const { LoadingSection } = require('commonsComponents/loadingSection');
// @ components
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { OKLink } = require('commonsComponents/OKLink');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const DateHelper = require('utilities/dateHelper');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { DATE_FORMAT_MONTH_YEAR } = require('constants/index');

class LastStatementBox extends React.Component {
    render() {
        const { immStatements, cardId } = this.props;
        let innerComponent;

        if (immStatements && !immStatements.get('loading')) {

            if (immStatements.get('byOrder').size > 0) {
                const immLastStatement = immStatements.get('byId').get(immStatements.get('byOrder').first());
                const date = DateHelper.buildFormattedDate(immLastStatement.get('date'), DATE_FORMAT_MONTH_YEAR);
                const statementId = immLastStatement.get('id');
                const plainAmountObject = getPlainAmountObject(immLastStatement.get('amount'));

                innerComponent = (
                    <OKSectionBox>
                        <h3 className="last-statement-box__title">
                            <FormattedText
                                value="cardsStatements-lastStatementBoxTitlePrefix"
                                injectedStrings={[date]}
                            />
                        </h3>
                        <OKInformativeList>
                            <OKInformativeListItem title="cardsStatements-lastStatementBoxSettlementDate" bodyText={date} />
                            <OKInformativeListItem title="cardsStatements-lastStatementBoxChargeAmount">
                                <div className="last-statement-box__information-section">
                                    <OneLineSymbolAmount
                                        amountObject={plainAmountObject}
                                        language={getLanguage()}
                                        amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                                </div>
                            </OKInformativeListItem>
                            <OKInformativeListItem title="cardsStatements-lastStatementBoxPaymentMethod">
                                <div className="last-statement-box__information-section">
                                    {immLastStatement.get('paymentMethod')}
                                </div>
                            </OKInformativeListItem>
                            <section>
                                <OKLink
                                    modifier="emphasize"
                                    to={`/myprofile/cards/${cardId}/statement/${statementId}`}
                                >
                                    <FormattedText value="cardsStatements-lastStatementBoxShowFullStatement" />
                                </OKLink>
                            </section>

                        </OKInformativeList>
                    </OKSectionBox>
                );
            }
        } else if (immStatements.get('loading')) {
            innerComponent = (
                <OKSectionBox>
                    <LoadingSection />
                </OKSectionBox>
            );
        }

        return (
            <div className="last-statement-box">
                {innerComponent}
            </div>
        )
    }
}

LastStatementBox.propTypes = {
    immStatements: PropTypes.object,
    cardId: PropTypes.string.isRequired
}

module.exports = LastStatementBox;
